<script lang="ts">
    import { Col, Dropdown, DropdownItem,DropdownMenu, DropdownToggle } from "sveltestrap";
    import { Active, Disabled, DisableMessage, DropdownButton, DropdownWithDisable, Normal } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" xl="6">
    <Card CardBodyprops="dropdown-basic">
      <div slot="customHeader2">
        <h5>{DropdownWithDisable}</h5>
        <span>{@html DisableMessage}</span>
      </div>
      <div slot="contentbody">
        <Dropdown direction="up">
          <DropdownToggle color="primary" class="rounded-0">{DropdownButton}
            <span><i class="icofont icofont-arrow-down"></i></span>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem >{Normal}</DropdownItem>
            <DropdownItem divider />
            <DropdownItem  active>{Active}</DropdownItem>
            <DropdownItem divider />
            <DropdownItem  disabled>{Disabled}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Card>
</Col> 